import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/QuickActionsColumn.css';
import { CalendarIcon, ListIcon, UsersIcon } from './icons/quick-actions/QuickActionIcons';

const MeetingsQuickActionsColumn = () => {
  const navigate = useNavigate();

  const actions = [
    { icon: <UsersIcon />, title: 'Add Meeting', onClick: () => navigate('/app/overview/meetings/new') },
    { icon: <ListIcon />, title: 'View All Meetings', onClick: () => navigate('/app/overview/meetings/list') },
    { icon: <CalendarIcon />, title: 'View Calendar', onClick: () => navigate('/app/overview/calendar') },
  ];

  return (
    <div className="quick-actions-container">
      <div className="quick-actions-grid">
        {actions.map((action) => (
          <button
            key={action.title}
            type="button"
            className="quick-action-button"
            onClick={action.onClick}
          >
            <span className="quick-action-icon">{action.icon}</span>
            <span className="quick-action-label">{action.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MeetingsQuickActionsColumn;
